// Room permission bitflags.
//
// MVP exposes three flags (KICK / IMAGEPASTE / CLEAR). The legacy Java version
// shipped a 4-flag bitmask, but per protocol-events.md §2.10 (設計判断メモ)
// we deliberately do NOT inherit it — additional flags can be appended in
// the future without breaking compatibility.
//
// Phase 7 Task 7-5: `CLEAR = 1 << 2` を追加. `whiteboard.clear` の権限制御で
// 使う. `rooms.clearOpen = true` のルームでは無権限ユーザでも clear 可能、
// `false` のルームでは `Perm.CLEAR` 保有者のみ clear 可能 (architecture.md
// §18.5 / protocol-events.md §4.5 の確定方針).
//
// `visitor` connections receive `0`; `credential` connections receive
// `room_credentials.permissions` from the database.
/**
 * Bitflag values for room-scoped permissions.
 *
 * Use `hasPerm(perms, Perm.KICK)` rather than `perms & Perm.KICK` directly
 * so that callers don't need to know the underlying representation.
 */
export const Perm = {
    /** Caller may kick other members from the room. */
    KICK: 1 << 0,
    /** Caller may upload an image via the `whiteboard.imagepaste-*` flow. */
    IMAGEPASTE: 1 << 1,
    /**
     * Caller may issue `whiteboard.clear` regardless of `rooms.clearOpen`.
     *
     * Phase 7 Task 7-5: `clearOpen=true` のルームでは無権限ユーザも clear 可、
     * `clearOpen=false` (default) では本フラグ保有者のみ clear 可. server-side
     * の `WhiteboardService.handleClear` が判定する.
     */
    CLEAR: 1 << 2,
};
/** Returns true iff every bit in `flag` is set in `perms`. */
export const hasPerm = (perms, flag) => (perms & flag) === flag;
/** Bitwise OR of every defined flag — useful for tests / admin defaults. */
export const ALL_PERMS = Object.values(Perm).reduce((acc, f) => acc | f, 0);
/** Visitor (anonymous) connections receive no permissions. */
export const VISITOR_PERMS = 0;
//# sourceMappingURL=permissions.js.map